var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"build-info text-caption text--secondary"},[_c('span',[_vm._v(_vm._s(_vm.buildId))])])
}
var staticRenderFns = []

export { render, staticRenderFns }